export const iconFontAwesomeTravelHotelFerry = (
	<i className="fa-solid fa-ferry"></i>
);
